export default __webpack_public_path__ + "static/media/sidebarlogo.c731e83e.svg";